define('ember-data/-private', ['exports', '@ember-data/store', '@ember/application/namespace', 'ember', 'ember-data/version', '@ember-data/model/-private', '@ember-data/store/-private', '@ember-data/record-data/-private'], (function (exports, store, Namespace, Ember, VERSION, Private, Private$1, Private$2) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var store__default = /*#__PURE__*/_interopDefaultLegacy(store);
  var Namespace__default = /*#__PURE__*/_interopDefaultLegacy(Namespace);
  var Ember__default = /*#__PURE__*/_interopDefaultLegacy(Ember);
  var VERSION__default = /*#__PURE__*/_interopDefaultLegacy(VERSION);

  const DS = Namespace__default["default"].create({
    VERSION: VERSION__default["default"],
    name: 'DS'
  });
  if (Ember__default["default"].libraries) {
    Ember__default["default"].libraries.registerCoreLibrary('Ember Data', VERSION__default["default"]);
  }

  Object.defineProperty(exports, 'Store', {
    enumerable: true,
    get: function () { return store__default["default"]; }
  });
  Object.defineProperty(exports, 'Errors', {
    enumerable: true,
    get: function () { return Private.Errors; }
  });
  Object.defineProperty(exports, 'ManyArray', {
    enumerable: true,
    get: function () { return Private.ManyArray; }
  });
  Object.defineProperty(exports, 'PromiseManyArray', {
    enumerable: true,
    get: function () { return Private.PromiseManyArray; }
  });
  Object.defineProperty(exports, 'AdapterPopulatedRecordArray', {
    enumerable: true,
    get: function () { return Private$1.AdapterPopulatedRecordArray; }
  });
  Object.defineProperty(exports, 'InternalModel', {
    enumerable: true,
    get: function () { return Private$1.InternalModel; }
  });
  Object.defineProperty(exports, 'PromiseArray', {
    enumerable: true,
    get: function () { return Private$1.PromiseArray; }
  });
  Object.defineProperty(exports, 'PromiseObject', {
    enumerable: true,
    get: function () { return Private$1.PromiseObject; }
  });
  Object.defineProperty(exports, 'RecordArray', {
    enumerable: true,
    get: function () { return Private$1.RecordArray; }
  });
  Object.defineProperty(exports, 'RecordArrayManager', {
    enumerable: true,
    get: function () { return Private$1.RecordArrayManager; }
  });
  Object.defineProperty(exports, 'RootState', {
    enumerable: true,
    get: function () { return Private$1.RootState; }
  });
  Object.defineProperty(exports, 'Snapshot', {
    enumerable: true,
    get: function () { return Private$1.Snapshot; }
  });
  Object.defineProperty(exports, 'SnapshotRecordArray', {
    enumerable: true,
    get: function () { return Private$1.SnapshotRecordArray; }
  });
  Object.defineProperty(exports, 'coerceId', {
    enumerable: true,
    get: function () { return Private$1.coerceId; }
  });
  Object.defineProperty(exports, 'normalizeModelName', {
    enumerable: true,
    get: function () { return Private$1.normalizeModelName; }
  });
  Object.defineProperty(exports, 'RecordData', {
    enumerable: true,
    get: function () { return Private$2.RecordData; }
  });
  Object.defineProperty(exports, 'Relationship', {
    enumerable: true,
    get: function () { return Private$2.Relationship; }
  });
  exports.DS = DS;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
